import React from 'react';
import { Card, CardBody } from 'reactstrap';
import {
  FaSlidersH,
  FaEnvelope,
  FaBell,
  FaExclamationTriangle,
  FaChevronRight,
} from 'react-icons/fa';

const AlertConfigCard = ({ onOpenConfig }) => {
  return (
    <Card
      className="mb-3"
      style={{
        backgroundColor: '#ffffff',
        border: '1px solid #e7ebf0',
        borderRadius: '8px',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.03)',
      }}
    >
      <CardBody
        style={{
          padding: '14px 12px 10px',
        }}
      >
        <div
          style={{
            fontSize: '13px',
            fontWeight: '700',
            color: '#1f2937',
            marginBottom: '2px',
          }}
        >
          Configuración de Alertas
        </div>

        <div
          style={{
            fontSize: '10px',
            color: '#64748b',
            marginBottom: '12px',
          }}
        >
          Gestiona tus reglas y preferencias de notificación
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '8px',
          }}
        >
          <div
            style={{
              border: '1px solid #e5e9ef',
              borderRadius: '6px',
              padding: '10px 8px',
              minHeight: '96px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <FaBell
              size={20}
              style={{
                color: '#64748b',
                marginBottom: '8px',
              }}
            />

            <div
              style={{
                fontSize: '10px',
                fontWeight: '700',
                color: '#273142',
                marginBottom: '2px',
              }}
            >
              Reglas de Alertas
            </div>

            <div
              style={{
                fontSize: '9px',
                lineHeight: '1.4',
                color: '#64748b',
              }}
            >
              Crea y edita reglas
              <br />
              personalizadas
            </div>
          </div>

          <div
            style={{
              border: '1px solid #e5e9ef',
              borderRadius: '6px',
              padding: '10px 8px',
              minHeight: '96px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <FaEnvelope
              size={20}
              style={{
                color: '#16a34a',
                marginBottom: '8px',
              }}
            />

            <div
              style={{
                fontSize: '10px',
                fontWeight: '700',
                color: '#273142',
                marginBottom: '2px',
              }}
            >
              Canales de Notificación
            </div>

            <div
              style={{
                fontSize: '9px',
                lineHeight: '1.4',
                color: '#64748b',
              }}
            >
              Email, SMS y notificaciones
              <br />
              push
            </div>
          </div>

          <div
            style={{
              border: '1px solid #e5e9ef',
              borderRadius: '6px',
              padding: '10px 8px',
              minHeight: '96px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <FaSlidersH
              size={20}
              style={{
                color: '#64748b',
                marginBottom: '8px',
              }}
            />

            <div
              style={{
                fontSize: '10px',
                fontWeight: '700',
                color: '#273142',
                marginBottom: '2px',
              }}
            >
              Umbrales y Parámetros
            </div>

            <div
              style={{
                fontSize: '9px',
                lineHeight: '1.4',
                color: '#64748b',
              }}
            >
              Configura límites y
              <br />
              condiciones
            </div>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '10px',
          }}
        >
          <button
            type="button"
            onClick={onOpenConfig}
            style={{
              border: 'none',
              background: 'transparent',
              padding: '0',
              color: '#2563eb',
              fontSize: '10px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              cursor: 'pointer',
            }}
          >
            Ir a la configuración de alertas
            <FaChevronRight size={8} />
          </button>
        </div>
      </CardBody>
    </Card>
  );
};

export default AlertConfigCard;